<template>
    <div class="header">
        <img src="../../src/assets/logo_cds.png" alt="">
      </div>
</template>

<style>
.header {
  position: relative; 
  margin-left: auto;
  margin-right: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 30vh;
  text-align: center;
  background-color: rgb(0, 0, 0);
  z-index: 2; 
  box-shadow: 10px 20px 10px rgba(0, 0, 0, 0.459);
}

.header img {
  width: 100%; /* Ajustar la imagen al 100% del ancho del contenedor */
  height: 100%; /* Ajustar la altura al 100% del contenedor */
  object-fit: contain; /* Ajustar la imagen manteniendo la proporción y contenida en el contenedor */
}
</style>